<script>
    import { getContext } from "svelte";
    import { key } from "../context/cinemaTileDimension";
    import { key as add2BasketButtonCtxKey, supportedColors as add2BasketButtonColors, ButtonColor } from "../context/add2BasketButton.js";
    import Add2BasketButton from "./Add2BasketButton.svelte";
    import Price from "./Price.svelte";
    import TopInfo from "./TopInfo.svelte";

    /**
 *
 *
 *
 *
 *
 *
 *
 *
 */

    /*                */
    let {
        brandName,
        variation,
        pricing,
        showTopInfo = false,
        widgetAdditionalClickTracking,
        additionalClickTracking,
        add2BasketVisibleTrack,
    } = $props();

    const add2BasketButton = getContext(add2BasketButtonCtxKey);

    const tileDimensions = getContext(key);
</script>

<div style:width={`${tileDimensions.width}px`} class="reco_cinema__information-container">
    <div class="reco_cinema__brand oc-copy-75">
        {brandName}
    </div>
    <div class="reco_cinema__name oc-copy-100">
        {variation.name}
    </div>
    {#if add2BasketButtonColors.includes(add2BasketButton?.buttonColor)}
        <div class="oc-mt-50 oc-mb-50">
            <Add2BasketButton
                variationId={variation.id}
                {widgetAdditionalClickTracking}
                {additionalClickTracking}
                isRedVariant={add2BasketButton?.buttonColor === ButtonColor.RED}
                {add2BasketVisibleTrack}
            />
        </div>
    {/if}
    {#if showTopInfo}
        <div data-testid="product_top_info">
            <TopInfo {variation} />
        </div>
    {/if}

    <Price {pricing} highlightText={variation.highlightText} />
</div>

<style lang="scss">
    :root {
        --padding_within_cell: 8px;
    }

    .reco_cinema__brand {
        text-transform: uppercase;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .reco_cinema__information-container {
        text-align: left;
        overflow: hidden;
        max-width: 100%;
        margin-top: 8px;
    }

    .reco_cinema__name {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
</style>
